import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('GlobalStore', {
  state: () => ({
    is_router_error:  false
  })
})